import axios from 'axios';
import { configs } from '../app/app-configs';
import { Note, NoteCreateRequest, NoteSummary, NoteUpdateRequest } from './model/note.model';
import { PaginatedResponse } from './model/paginated-response';
import { Pagination } from '../model/pagination';

export const getNoteSummary = async (): Promise<NoteSummary> => {
    return await axios.get(`${configs.BASE_URL}/notes/summary`).then((res) => {
        return res.data as NoteSummary;
    });
};

export const getNotesByBusinessId = async (
    pagination: Pagination
): Promise<PaginatedResponse<Note>> => {
    return await axios
        .get(
            `${configs.BASE_URL}/notes?page=${pagination.page}&size=${pagination.size}`
        )
        .then((res) => {
            return res.data as PaginatedResponse<Note>;
        });
};

export const getNotesByMemberId = async (
    memberId: number,
    pagination: Pagination
): Promise<PaginatedResponse<Note>> => {
    return await axios
        .get(
            `${configs.BASE_URL}/notes/member/${memberId}?page=${pagination.page}&size=${pagination.size}`
        )
        .then((res) => {
            return res.data as PaginatedResponse<Note>;
        });
};

export const getNotesByUserId = async (
    userId: number,
    pagination: Pagination
): Promise<PaginatedResponse<Note>> => {
    return await axios
        .get(
            `${configs.BASE_URL}/notes/user/${userId}?page=${pagination.page}&size=${pagination.size}`
        )
        .then((res) => {
            return res.data as PaginatedResponse<Note>;
        });
};

export const getnoteById = async (id: number): Promise<Note> => {
    return await axios.get(`${configs.BASE_URL}/notes/${id}`).then((res) => {
        return res.data as Note;
    });
};

export const createNote = async (request: NoteCreateRequest): Promise<Note> => {
    return await axios
        .post(`${configs.BASE_URL}/notes`, request)
        .then((res) => {
            return res.data as Note;
        });
};

export const updateNote = async (request: NoteUpdateRequest): Promise<Note> => {
    return await axios
        .put(`${configs.BASE_URL}/notes/${request.id}`, request)
        .then((res) => {
            return res.data as Note;
        });
};

export const deleteNote = async (id: number): Promise<number> => {
    return await axios.delete(`${configs.BASE_URL}/notes/${id}`).then((res) => {
        return res.data;
    });
};
